<template>
  <div>
    <AdminTableContainer
      :headers="headers"
      :users="localUsers"
      :options="options"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AdminTableContainer from '../../components/AdminTableContainer'

export default {
  name: 'GroupUsers',
  components: { AdminTableContainer },
  data() {
    return {
      headers: ['name', 'parents', 'email', 'phone'],
      localUsers: {},
      options: {
        sortable: true,
        actions: ['accountMgmt']
      },
      title: 'Loading...'
    }
  },
  computed: {
    ...mapGetters(['group'])
  },
  mounted: async function () {
    this.title = this.group.name
    this.localUsers = {
      data: [...this.group.inactiveMembers, ...this.group.activeMembers],
      page: 1,
      pageSize: 25,
      total: [...this.group.inactiveMembers, ...this.group.activeMembers].length
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/Pages/GroupMgmt/GroupUsers.vue?3e232bc9